<template>
  <div 
    class="box" 
    ref="mainBox"
    @touchstart="touchmoveChannelsHandler($event)"
    @touchmove="touchmoveChannelsHandler($event)"
    @touchend="touchmoveChannelsHandler($event)"
  >
    <img @click="clickImg(index)" v-for="(img,index) in imgList" :src="img" :style="{zIndex:3-Math.abs(myList.indexOf(index) - 1)}" :ref="`imgDom`">
  </div>
</template>

<script>

  export default {
    props: ['imgList','value','autoMove'],
    data(){
      return {
        startTouchPointX:0,
        startTouchScrollLeft:0,
        maxScrollLeft:0,
        moving:false,

        index:0,

        moveTime:0,
        nextMove:0,
      }
    },
    watch:{
      imgList(){
        this.init();
      },
      value(){
        this.index = this.value || 0;
      },
    },
    computed: {
      myList(){
        if(this.imgList.length == 0){
          return []
        }
        if(this.imgList.length == 1){
          return [0]
        }
        let left = this.index - 1;
        let right = this.index + 1;
        if(left < 0){
          left = this.imgList.length - 1;
        }
        if(right >= this.imgList.length){
          right = 0;
        }
        return [left,this.index,right];
      }
    },
    methods: {
      touchmoveChannelsHandler($event){
        if(this.imgList.length <= 1){
          return;
        }
        const type = $event.type;
        const style = this.$refs.mainBox.style;
        if(type === 'touchstart'){
          this.startTouchPointX = $event.changedTouches[0].pageX;
        } else if(type === 'touchmove'){
          let currentMoved = this.startTouchPointX - $event.changedTouches[0].pageX;
          if(currentMoved > this.$refs.mainBox.clientWidth){
            currentMoved = this.$refs.mainBox.clientWidth
          }
          if(currentMoved < -this.$refs.mainBox.clientWidth){
            currentMoved = -this.$refs.mainBox.clientWidth
          }
          if(currentMoved>0){
            this.$refs.imgDom[this.myList[2]].style.left = (this.$refs.mainBox.clientWidth - currentMoved) + 'px';
            this.$refs.imgDom[this.myList[1]].style.left =  -currentMoved + 'px';

            // this.$refs.imgDom[this.myList[0]].style.left = (2*this.$refs.mainBox.clientWidth - currentMoved) + 'px';
          }else{
            this.$refs.imgDom[this.myList[0]].style.left = (-this.$refs.mainBox.clientWidth - currentMoved) + 'px';
            this.$refs.imgDom[this.myList[1]].style.left =  -currentMoved + 'px';

            // this.$refs.imgDom[this.myList[2]].style.left = (2*-this.$refs.mainBox.clientWidth - currentMoved) + 'px';
          }
          // this.$refs.mainBox.scrollLeft = currentScrollLeft;
        } else if(type === 'touchend'){
          let currentMoved = this.startTouchPointX - $event.changedTouches[0].pageX;
          let way = currentMoved > 0?1:(currentMoved < 0?-1:0);
          let next = false;
          if(currentMoved > this.$refs.mainBox.clientWidth/2){
            next = true
            this.index++;
            if(this.index >= this.imgList.length){
              this.index = 0;
            }
          }else if(-currentMoved > this.$refs.mainBox.clientWidth/2){
            next = true
            this.index--;
            if(this.index < 0){
              this.index = this.imgList.length-1;
            }
          }


          this.moveRun(way,next);
          /*setTimeout(()=>{
            this.init(way,next);
            for(let key in this.myList){
              let dom = this.$refs.imgDom[this.myList[key]];
              if(next && (key == (1 + way))){
                continue;
              }
              
              if(dom){
                dom.classList.add('smooth-back');
                
                (()=>{
                  setTimeout(()=>{
                    dom.classList.remove('smooth-back');
                  }, 300);
                })(dom);
              }
            }
            // for(let dom of this.$refs.imgDom){
            //   dom.classList.add('smooth-back')
            //   this.init();
            //   (()=>{
            //     setTimeout(()=>{
            //       dom.classList.remove('smooth-back');
            //     }, 300);
            //   })(dom);
              
            // }
          },0);*/
        }
      },
      init(way = 0,next = false){//way图片移动方向，正左负右，next是否移动到下一张
        if(!this.$refs.mainBox){
          setTimeout(()=>{
            this.init(way,next)
          },10);
          return
        }
        this.$nextTick(()=>{
          if(this.imgList.length > 2){
            for(let index in this.$refs[`imgDom`]){
              let key = this.myList.indexOf(+index);
              this.$refs[`imgDom`][index].style.left = (key - 1) * this.$refs.mainBox.clientWidth + 'px';
            }
            /*for(let key in this.myList){
              this.$refs[`imgDom`][this.myList[key]].style.left = (key - 1) * this.$refs.mainBox.clientWidth + 'px';
            }*/
            // this.$refs.imgDom[0].style.right = this.$refs.mainBox.clientWidth + 'px';
            // this.$refs.imgDom[2].style.left = this.$refs.mainBox.clientWidth + 'px';
            // this.$refs.imgDom[1].style.left = 0 + 'px';
            // this.$refs.mainBox.scrollLeft = this.$refs.mainBox.clientWidth;
          }else if(this.imgList.length > 1){
            this.$refs[`imgDom`][this.myList[1]].style.left = '0px';
            if(next){
              this.$refs[`imgDom`][this.myList[(1 - way)]].style.left = ((1 - way) - 1) * this.$refs.mainBox.clientWidth + 'px';
            }else{
              this.$refs[`imgDom`][this.myList[(1 + way)]].style.left = ((1 + way) - 1) * this.$refs.mainBox.clientWidth + 'px';
            }
          }
        })
        // console.log(this.imgList.length,123)
        
      },
      moveRun(way,next){
        this.nextMove = this.moveTime;
        this.moving = true;
        setTimeout(()=>{
          this.init(way,true);
          for(let key in this.myList){
            let dom = this.$refs.imgDom[this.myList[key]];
            if(next && (key == (1 + way))){
              continue;
            }
            
            if(dom){
              dom.classList.add('smooth-back');
              
              (()=>{
                setTimeout(()=>{
                  dom.classList.remove('smooth-back');
                  this.moving = false;
                }, 300);
              })(dom);
            }
          }
          this.$emit('input',this.index)
        },0);
      },
      move(way){
        if(this.moving){
          return
        }
        if(way > 0){
          way = 1;
          this.index++;
          if(this.index >= this.imgList.length){
            this.index = 0;
          }
        }else if(-way > 0){
          way = -1;
          this.index--;
          if(this.index < 0){
            this.index = this.imgList.length-1;
          }
        }
        this.moveRun(way,true);

        
      },
      clickImg(index){
        this.$emit('clickImg',this.index)
      },
      nextMoveTimer(){
        if(this.nextMove <= 0){
          this.nextMove = this.moveTime;
          this.move(1)
        }else{
          this.nextMove--;
        }
        setTimeout(()=>{this.nextMoveTimer()},1000)
      }
    },
    created(){
      console.log(123)
      this.index = this.value || 0;
      if(this.autoMove){
        if(typeof this.autoMove == "number" && this.autoMove >= 1){
          this.moveTime = this.autoMove
        }else{
          this.moveTime = 10;
        }
        this.nextMove = this.moveTime;
        this.nextMoveTimer();
      }
      this.init();
      
    },
    mounted(){
      this.init();
    }
  }
</script>

<style scoped lang="scss">
  .smooth-back{
    transition: all 0.3s ease-in-out;
  }
  .box{
    display: flex;
    overflow: hidden;
    position: relative;
    img{
      width: 100%;
      height: 100%;
      position: absolute;
    }
  }
</style>
